import React from 'react';
import { Carousel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function AppHero() {
  const { t } = useTranslation();
  
  // Define hero data with translations
  const heroData = [
    {
      id: 1,
      image: require('../assets/images/hero/hero-1.jpeg'),
      title: t('heroSlide1Title'),
      description: t('heroSlide1Desc'),
      link: 'https://reactjs.org/',
    },
    {
      id: 2,
      image: require('../assets/images/hero/hero-2.jpeg'),
      title: t('heroSlide2Title'),
      description: t('heroSlide2Desc'),
      link: 'https://reactjs.org/',
    },
    {
      id: 3,
      image: require('../assets/images/hero/hero-3.jpeg'),
      title: t('heroSlide3Title'),
      description: t('heroSlide3Desc'),
      link: 'https://reactjs.org/',
    }
  ];

  return (
    <section id="home" className="hero-block">
      <Carousel>
        {
          heroData.map(hero => {
            return (
              <Carousel.Item key={hero.id}>
                <img
                  className="d-block w-100"
                  src={hero.image}
                  alt={t('heroSlideAlt') + hero.id}
                />
                <Carousel.Caption>
                  <h3>{hero.title}</h3>
                  <p>{hero.description}</p>
                  <a className="btn btn-primary" href={process.env.PUBLIC_URL + "contact"}>{t('contact')}</a>
                </Carousel.Caption>
              </Carousel.Item>
            );
          })
        }
      </Carousel>
    </section>
  );
}

export default AppHero;
